import { render, staticRenderFns } from "./loadingPalletTocan.vue?vue&type=template&id=ead6b0ba&"
import script from "./loadingPalletTocan.vue?vue&type=script&lang=js&"
export * from "./loadingPalletTocan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports